import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { adminApi, errMsg } from "@/lib/api";
import { PageTitle, Btn, Pill, Panel } from "@/admin/ui";

const EMPTY = { label: "", start: "", end: "", cutoff: "", capacity: 20, active: true, sort: 0 };

const SlotRow = ({ slot, onSaved }) => {
  const [f, setF] = useState(slot);
  const isNew = !slot.id;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (extra = {}) => {
    const body = { label: f.label, start: f.start, end: f.end, cutoff: f.cutoff, capacity: parseInt(f.capacity, 10) || 0, active: f.active, sort: parseInt(f.sort, 10) || 0, ...extra };
    try { isNew ? await adminApi.post("/slots", body) : await adminApi.put(`/slots/${slot.id}`, body); toast.success("Slot saved"); onSaved(); if (isNew) setF(EMPTY); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const tid = slot.id || "new";
  return (
    <div className="grid grid-cols-2 md:grid-cols-[1.3fr_repeat(4,0.8fr)_auto_auto] gap-2 items-center py-2" data-testid={`slot-row-${tid}`}>
      <Input value={f.label} onChange={set("label")} placeholder="Label" className="h-9" data-testid={`slot-label-${tid}`} />
      <Input type="time" value={f.start} onChange={set("start")} className="h-9" data-testid={`slot-start-${tid}`} />
      <Input type="time" value={f.end} onChange={set("end")} className="h-9" data-testid={`slot-end-${tid}`} />
      <Input type="time" value={f.cutoff} onChange={set("cutoff")} className="h-9" data-testid={`slot-cutoff-${tid}`} title="Order cutoff" />
      <Input type="number" value={f.capacity} onChange={set("capacity")} className="h-9" data-testid={`slot-capacity-${tid}`} title="Max orders" />
      <div className="flex items-center gap-2">
        {!isNew && <Switch checked={f.active} onCheckedChange={(v) => { setF({ ...f, active: v }); save({ active: v }); }} data-testid={`slot-active-${tid}`} />}
        {!isNew && <span className="text-xs text-stone-500 whitespace-nowrap">{slot.used}/{slot.capacity}</span>}
        {!isNew && !slot.available && <Pill tone="orange">{slot.reason}</Pill>}
      </div>
      <div className="flex gap-1">
        <Btn onClick={() => save()} data-testid={`slot-save-${tid}`}>{isNew ? "Add" : "Save"}</Btn>
        {!isNew && <button onClick={() => window.confirm("Delete slot?") && adminApi.delete(`/slots/${slot.id}`).then(onSaved)} className="p-2 text-stone-500 hover:text-accent" data-testid={`slot-delete-${tid}`}><Trash2 className="w-4 h-4" /></button>}
      </div>
    </div>
  );
};

export default function AdminSlots() {
  const [slots, setSlots] = useState([]);
  const load = () => adminApi.get("/slots").then((r) => setSlots(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div>
      <PageTitle sub="Same-day only. Slots close automatically at the cutoff time or when capacity is reached.">Delivery slots</PageTitle>
      <Panel title="Label · start · end · order cutoff · capacity" testId="slots-editor">
        <div className="divide-y divide-stone-100">
          {slots.map((s) => <SlotRow key={`${s.id}-${s.used}-${s.capacity}-${s.active}`} slot={s} onSaved={load} />)}
          <SlotRow slot={EMPTY} onSaved={load} />
        </div>
      </Panel>
    </div>
  );
}
